/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Stack, Grid } from '@mui/material';
import React, { useEffect } from 'react';
import ParentMainDashboard from './ParentMainDashboard';
import { Container, Image } from 'react-bootstrap';
import { useAppSelector } from 'app/hooks';
import { routers } from 'router/router';
import { useHistory } from 'react-router-dom';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import LibraryBooksRoundedIcon from '@mui/icons-material/LibraryBooksRounded';
import EducationProgramsIcon from 'components/icons/EducationProgramsIcon';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import CamAppIcon from 'components/icons/CamAppIcon';
import counselorServices from 'services/counselorServices';
import { getDefaultCounselorStudentId } from 'components/helper/helper';
import { get } from 'lodash';
import toast from 'react-hot-toast';
import { getAccessToken } from 'utils/sessionStorage';
import { getCamBaseUrl, isGradMapSessionValid, notifyCamSessionExpired, openInCam, showCamPopupBlockedToast } from 'utils/camAuth';
import { STRIPE_PRICE_NAME } from 'constants/common';

const disabledCard = {
  opacity: 0.5,
  pointerEvents: 'none',
  cursor: 'not-allowed',
  '&:hover': {
    transform: 'none',
    boxShadow: 'none',
    border: '1px solid #D6DBE6',
    backgroundColor: '#fff',
  },
};

interface Props {}

const DashBoardPage = (props: Props) => {
  const [totalStudent, setTotalStudent] = React.useState(0);
  const [isWelcomeLoaded, setIsWelcomeLoaded] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const history = useHistory();
  const personalStore = useAppSelector((store) => store.basicInformation.myBasicInformation);
  const basicInfoStatus = useAppSelector((store) => store.basicInformation.status);
  const userRole: string = personalStore?.user_role ?? '';

  // Wait for role to be loaded before showing role-specific UI (avoids flashing student dashboard for counselor/parent)
  const hasToken = !!getAccessToken();
  const isRoleLoaded = !!(personalStore?.user_role);
  const isRoleLoading =
    hasToken &&
    !isRoleLoaded &&
    basicInfoStatus !== 'failed' &&
    (basicInfoStatus === 'loading' || !personalStore);

  useEffect(() => {
    document.body.style.backgroundColor = userRole === 'parent' ? '#F6F7FB' : '#eff6ff';
    return () => {
      document.body.style.backgroundColor = 'unset';
    };
  }, [userRole]);

  const stripeSubscriptionInfo = useAppSelector(
    (store: any) => store.basicInformation.stripeSubscriptionInfo
  );
  const planName: string = stripeSubscriptionInfo?.subcription_plan ?? STRIPE_PRICE_NAME.GradMapStarter;
  const isStarter = planName === STRIPE_PRICE_NAME.GradMapStarter;

  const handleOpenCam = React.useCallback(async () => {
    let hasToken = !!getAccessToken();
    if (!hasToken) {
      notifyCamSessionExpired();
      return;
    }

    // Token is present but may already be expired/revoked server-side —
    // confirm with the backend before handing it off to CAM.
    const sessionValid = await isGradMapSessionValid();
    if (!sessionValid) {
      notifyCamSessionExpired();
      return;
    }

    if (!getCamBaseUrl()) {
      toast.error('CAM is not configured. Please contact support.');
      return;
    }
    if (!openInCam('/')) {
      showCamPopupBlockedToast(toast.error);
    }
  }, []);

  useEffect(() => {
    const userId = get(personalStore, 'student_id', null);
    if (userId && userRole === 'counselor') {
      counselorServices.getPartner(userId).then((res) => {
        setTotalStudent(res?.length);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personalStore?.student_id, userRole]);

  useEffect(() => {
    // Add loading animation for welcome section
    const timer = setTimeout(() => {
      setIsWelcomeLoaded(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Handle responsive detection
    const handleResize = () => {
      setIsMobile(isMobile);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  sessionStorage.setItem('isDashBoardLoaded', 'true');
  sessionStorage.setItem('session_student_id', personalStore?.student_id);
  return (
    <>
      {isRoleLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(255,255,255,0.95)',
            zIndex: 9998,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div style={{ textAlign: 'center' }}>
            <div
              className="spinner-border text-primary"
              role="status"
              style={{ width: 60, height: 60, fontSize: 32 }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <div style={{ marginTop: 16, fontWeight: 500, fontSize: 18, color: '#212529' }}>
              Loading...
            </div>
          </div>
        </div>
      )}
      <Container
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          // minHeight: '100vh',
          padding: isMobile ? '12px' : '20px',
          margin: '0 auto',
        }}
      >
        {/* <Image src="./assets/images/Banner.svg" width="100%" style={{ marginTop: '2.5rem' }} /> */}
        {userRole === 'parent' ? (
          <ParentMainDashboard />
        ) : userRole === 'counselor' ? (
          <div style={{ width: '100%', maxWidth: '1200px' }}>
            <Box
              className="my-3 p-4"
              sx={{
                background: 'linear-gradient(90deg, #4d88f0 0%, #8cb5f3 100%)',
                borderRadius: '24px',
                color: 'white',
                transform: isWelcomeLoaded ? 'scale(1)' : 'scale(0.95)',
                opacity: isWelcomeLoaded ? 1 : 0.8,
                transition: 'all 0.5s ease-in-out',
                boxShadow: '0 8px 32px rgba(77, 136, 240, 0.2)',
              }}
            >
              <Stack
                direction={isMobile ? 'column' : 'row'}
                alignItems={'center'}
                spacing={isMobile ? 2 : 4}
                textAlign={isMobile ? 'center' : 'left'}
              >
                <Image
                  src="./assets/images/Icon-01.svg"
                  roundedCircle
                  width={isMobile ? '80px' : '100px'}
                />
                <Stack>
                  <div
                    style={{
                      fontSize: isMobile ? '24px' : '36px',
                      fontWeight: 700,
                      lineHeight: isMobile ? '1.2' : 'normal',
                    }}
                  >
                    Thank you for being a trusted partner! 👋
                  </div>
                  <div
                    style={{
                      fontSize: isMobile ? '16px' : '18px',
                      fontWeight: 400,
                      marginTop: isMobile ? '8px' : '0',
                    }}
                  >
                    You have {totalStudent} students who are excited to receive your feedback!
                  </div>
                </Stack>
              </Stack>
            </Box>

            <Stack
              direction="row"
              flexWrap="wrap"
              justifyContent={'center'}
              gap={isMobile ? 1 : 2}
              sx={{
                padding: isMobile ? '20px 0px' : '40px 0px',
              }}
            >
              <Stack
                sx={{
                  ...sx.stackGroup,
                  minWidth: isMobile ? '120px !important' : '176px !important',
                  height: isMobile ? '110px' : '140px',
                }}
                alignItems="center"
                justifyContent="center"
                onClick={async () => {
                  const counselorUserId = personalStore?.student_id;
                  if (!counselorUserId) {
                    toast.error('Unable to open students');
                    return;
                  }
                  try {
                    const res = await counselorServices.getPartner(counselorUserId);
                    const firstId = getDefaultCounselorStudentId(res);
                    if (firstId) {
                      history.push(routers.viewStudent.path.replace(':id', String(firstId)));
                    } else {
                      toast.error('No students linked yet');
                    }
                  } catch {
                    toast.error('Could not load students');
                  }
                }}
              >
                <div title="View Students" className="d-flex direction-column align-items-center">
                  <SupportAgentIcon
                    sx={{
                      fontSize: isMobile ? '40px' : '54px',
                      marginTop: '3px',
                      color: '#4d88f0',
                    }}
                  />
                  <Box
                    sx={{
                      ...sx.text,
                      fontSize: isMobile ? '14px' : '16px',
                      maxWidth: isMobile ? '110px' : '160px',
                      marginTop: isMobile ? '6px' : '8px',
                    }}
                  >
                    View Students
                  </Box>
                </div>
              </Stack>
              <Stack
                sx={{
                  ...sx.stackGroup,
                  minWidth: isMobile ? '120px !important' : '176px !important',
                  height: isMobile ? '110px' : '140px',
                }}
                alignItems="center"
                justifyContent="center"
                onClick={() => window.open('https://docs.gradmap.com/en', '_blank')}
              >
                <div title="Resources" className="d-flex direction-column align-items-center">
                  <InfoRoundedIcon
                    sx={{
                      fontSize: isMobile ? '40px' : '54px',
                      marginTop: '3px',
                      color: '#4d88f0',
                    }}
                  />
                  <Box
                    sx={{
                      ...sx.text,
                      fontSize: isMobile ? '14px' : '16px',
                      maxWidth: isMobile ? '110px' : '160px',
                      marginTop: isMobile ? '6px' : '8px',
                    }}
                  >
                    Resources
                  </Box>
                </div>
              </Stack>
              <Stack
                sx={{
                  ...sx.stackGroup,
                  minWidth: isMobile ? '120px !important' : '176px !important',
                  height: isMobile ? '110px' : '140px',
                }}
                alignItems="center"
                justifyContent="center"
                onClick={() => history.push(routers.settings.path + '?tab=3')}
              >
                <div title="Settings" className="d-flex direction-column align-items-center">
                  <LibraryBooksRoundedIcon
                    sx={{
                      fontSize: isMobile ? '40px' : '54px',
                      marginTop: '3px',
                      color: '#4d88f0',
                    }}
                  />
                  <Box
                    sx={{
                      ...sx.text,
                      fontSize: isMobile ? '14px' : '16px',
                      maxWidth: isMobile ? '110px' : '160px',
                      marginTop: isMobile ? '6px' : '8px',
                    }}
                  >
                    Settings
                  </Box>
                </div>
              </Stack>
            </Stack>

            <Box
              className="my-4 p-4"
              sx={{
                backgroundColor: '#fff',
                borderRadius: '16px',
                border: '1px solid #D6DBE6',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
                padding: isMobile ? '16px' : '24px',
                margin: isMobile ? '16px 0' : '24px 0',
              }}
            >
              <div
                style={{
                  fontSize: isMobile ? '18px' : '20px',
                  fontWeight: 600,
                  color: '#212529',
                  marginBottom: isMobile ? '12px' : '16px',
                }}
              >
                Getting Started
              </div>
              <div
                style={{
                  fontSize: isMobile ? '14px' : '16px',
                  color: '#6c757d',
                  lineHeight: '1.6',
                }}
              >
                <div style={{ marginBottom: isMobile ? '10px' : '12px' }}>
                  • Click "View Students" and you'll be able to see all your students on the
                  left-hand side.
                </div>
                <div style={{ marginBottom: isMobile ? '10px' : '12px' }}>
                  • Select a student and the section summaries will appear for you to review and
                  make comments below.
                </div>
                <div style={{ marginBottom: isMobile ? '10px' : '12px' }}>
                  • If you have any feedback on how we can make this a better experience for you,
                  please let us know!
                </div>
              </div>
            </Box>
          </div>
        ) : (
          <div style={{ width: '100%', maxWidth: '1200px' }}>
            <Box
              className="my-3 p-4"
              sx={{
                background: 'linear-gradient(90deg, #4d88f0 0%, #8cb5f3 100%)',
                borderRadius: '24px',
                color: 'white',
                transform: isWelcomeLoaded ? 'scale(1)' : 'scale(0.95)',
                opacity: isWelcomeLoaded ? 1 : 0.8,
                transition: 'all 0.5s ease-in-out',
                boxShadow: '0 8px 32px rgba(77, 136, 240, 0.2)',
              }}
            >
              <Stack
                direction={isMobile ? 'column' : 'row'}
                alignItems={'center'}
                spacing={isMobile ? 2 : 4}
                textAlign={isMobile ? 'center' : 'left'}
              >
                <Image
                  src="./assets/images/Icon-01.svg"
                  roundedCircle
                  width={isMobile ? '80px' : '100px'}
                />
                <Stack>
                  <div
                    style={{
                      fontSize: isMobile ? '24px' : '36px',
                      fontWeight: 700,
                      lineHeight: isMobile ? '1.2' : 'normal',
                    }}
                  >
                    Welcome {personalStore?.first_name ?? ''}! 👋
                  </div>
                  <div
                    style={{
                      fontSize: isMobile ? '16px' : '18px',
                      fontWeight: 400,
                      marginTop: isMobile ? '8px' : '0',
                    }}
                  >
                    Let's start your learning journey right now!
                  </div>
                </Stack>
              </Stack>
            </Box>

            <Grid
              container
              spacing={isMobile ? 1 : 2}
              justifyContent="center"
              sx={{ padding: isMobile ? '20px 0px' : '40px 0px' }}
            >
              {/* Row 1: 6 items */}
              {[
                {
                  label: 'Profile',
                  icon: './assets/icons/profile.svg',
                  onClick: () => history.push(routers.basicInformation.path),
                },
                {
                  label: 'Family',
                  icon: './assets/icons/family.svg',
                  onClick: () => history.push(routers.household.path),
                },
                {
                  label: 'Education',
                  icon: './assets/icons/tests.svg',
                  onClick: () => history.push(routers.highSchool.path),
                },
                {
                  label: 'Tests',
                  icon: './assets/icons/tests.svg',
                  onClick: () => history.push(routers.generalTest.path),
                },
                {
                  label: 'Courses & Grades',
                  icon: './assets/icons/education.svg',
                  onClick: () => history.push(routers.generalCourse.path),
                },
                {
                  label: 'Activities & Honors',
                  icon: './assets/icons/activity.svg',
                  onClick: () => history.push(routers.activities.path),
                },
              ].map((item) => (
                <Grid item xs={6} sm={4} md={2} key={item.label}>
                  <Stack
                    sx={{
                      ...sx.stackGroup,
                      minWidth: isMobile ? '120px !important' : '176px !important',
                      height: isMobile ? '110px' : '140px',
                    }}
                    alignItems="center"
                    justifyContent="center"
                    onClick={item.onClick}
                  >
                    <img alt={item.label} src={item.icon} width={isMobile ? 40 : 54} />
                    <Box
                      sx={{
                        ...sx.text,
                        fontSize: isMobile ? '14px' : '16px',
                        maxWidth: isMobile ? '110px' : '160px',
                        marginTop: isMobile ? '6px' : '8px',
                      }}
                    >
                      {item.label}
                    </Box>
                  </Stack>
                </Grid>
              ))}

              {/* Row 2: 6 items */}
              {[
                {
                  label: 'Educational Programs',
                  icon: (
                    <EducationProgramsIcon
                      sx={{ fontSize: isMobile ? 40 : 54, color: '#4d88f0' }}
                    />
                  ),
                  isDisabled: false,
                  onClick: () => history.push(routers.summerProgramsBrowser.path),
                },
                {
                  label: 'Colleges',
                  icon: (
                    <img
                      alt="Colleges"
                      src="./assets/icons/college.svg"
                      width={isMobile ? 40 : 54}
                    />
                  ),
                  isDisabled: false,
                  onClick: () => history.push(routers.collegeSearch.path),
                },
                {
                  label: 'Auto-fill',
                  icon: (
                    <img
                      alt="Auto-fill"
                      src="./assets/icons/download.svg"
                      width={isMobile ? 40 : 54}
                    />
                  ),
                  isDisabled: false,
                  onClick: () =>
                    window.open(
                      'https://chrome.google.com/webstore/detail/gradmap/fbmaejeklcgdlohlngjkkggddapoklli?hl=en&authuser=0',
                      '_blank'
                    ),
                },
                {
                  label: '',
                  icon: (
                    <>
                    <CamAppIcon
                      color={isStarter ? "disabled" : undefined}
                      sx={{ fontSize: isMobile ? 40 : 54, color: isStarter? '#bfc4d1': '#4d88f0' }}
                   />
                   <span className={isStarter?'cam-logo-txt-disable': 'cam-logo-txt'} title='CAM App'>CAM</span>
                   </>
                  ),
                  isDisabled: isStarter,
                  onClick: handleOpenCam,
                },
                {
                  label: 'Counselor',
                  icon: (
                    <SupportAgentIcon sx={{ fontSize: isMobile ? 40 : 54, color: '#4d88f0' }} />
                  ),
                  onClick: () => history.push(routers.settings.path + '?tab=3'),
                },
                {
                  label: 'Resources',
                  icon: <InfoRoundedIcon sx={{ fontSize: isMobile ? 40 : 54, color: '#4d88f0' }} />,
                  onClick: () => window.open('https://docs.gradmap.com/en', '_blank'),
                },
              ].map((item) => {
                const disabled = item.isDisabled;
                return (
                <Grid item xs={6} sm={4} md={2} key={`${item.label}`}>
                  <Stack
                    sx={{
                      ...sx.stackGroup,
                      ...(disabled && disabledCard),
                      minWidth: isMobile ? '120px !important' : '176px !important',
                      height: isMobile ? '110px' : '140px',
                    }}
                    alignItems="center"
                    justifyContent="center"
                    onClick={item.onClick}
                  >
                    {typeof item.icon === 'string' ? (
                      <img alt={`${item.label}`} src={item.icon} width={isMobile ? 40 : 54} />
                    ) : (
                      item.icon
                    )}
                    <Box
                      sx={{
                        ...sx.text,
                        fontSize: isMobile ? '14px' : '16px',
                        maxWidth: isMobile ? '110px' : '160px',
                        marginTop: isMobile ? '6px' : '8px',
                      }}
                    >
                      {item.label}
                    </Box>
                  </Stack>
                </Grid>
                );
              })}
            </Grid>
          </div>
        )}
      </Container>
    </>
  );
};

const sx = {
  stackGroup: {
    cursor: 'pointer',
    minWidth: '176px !important',
    height: '140px',
    backgroundColor: '#fff',
    borderRadius: '16px',
    justifyContent: 'center',
    border: '1px solid #D6DBE6',
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      transform: 'translateY(-8px)',
      boxShadow: '0 12px 24px rgba(77, 136, 240, 0.15)',
      border: '1px solid #4d88f0',
      backgroundColor: '#f8faff',
    },
  },
  text: {
    maxWidth: '160px',
    fontSize: '16px',
    fontWeight: 600,
    textAlign: 'center',
    marginTop: '8px',
    color: '#212529',
    lineHeight: 'normal',
  },
};
export default DashBoardPage;
